import { RiDashboardFill, RiFileUserFill } from "react-icons/ri";
import {
  ADMIN,
  CLIENT,
  CLIENT_VENDOR,
  PROJECT_COORDINATOR,
  SUBMISSION_SPECIALIST,
} from "../constants/roles";
import Dashboard from "../Pages/admin/DashboardPage";
import ClientPage from "../Pages/admin/ClientPage";
import EmployeePage from "../Pages/admin/EmplyoeePage";
import { BsFillPeopleFill } from "react-icons/bs";
import { MdBusiness } from "react-icons/md";
import VendorPage from "../Pages/admin/VendorPage";
import { GoProjectRoadmap } from "react-icons/go";
import ProjectPage from "../Pages/admin/ProjectPage";
import Projects from "../Pages/employee/Projects";
import Dash from "../Pages/employee/Dash";
import { MdAddBox } from "react-icons/md";

import ClientProjects from "../Pages/client/ClientProjects";
import ClientDashboard from "../Pages/client/dashboard";
import { File } from "lucide-react";
import Articles from "../Pages/admin/articles";
import ArticlesClient from "../Pages/client/articlesClient";
const routesdata = [
  {
    title: "Dashboard",
    path: "/admin/dashboard",
    icon: <RiDashboardFill size={20} />,
    element: <Dashboard />,
    children: [],
    role: [ADMIN],
  },
  {
    title: "Clients",
    path: "/clients",
    icon: <RiFileUserFill size={20} />,
    element: <ClientPage />,
    children: [],
    role: [ADMIN],
  },
  {
    title: "Employee",
    path: "/employee",
    icon: <BsFillPeopleFill size={20} />,
    element: <EmployeePage />,
    children: [],
    role: [ADMIN],
  },
  {
    title: "Vendor",
    path: "/vendor",
    icon: <MdBusiness size={20} />,
    element: <VendorPage />,
    children: [],
    role: [ADMIN],
  },
  {
    title: "Projects",
    path: "/projects",
    icon: <GoProjectRoadmap size={20} />,
    element: <ProjectPage />,
    children: [],
    role: [ADMIN],
  },

  {
    title: "Publication Status",
    path:"/admin/articles",
    icon: <File size={20} />,
    element: <Articles />,
    children: [],
    role: [ADMIN],
  },
  {
    title: "Dashboard",
    path: "/project-coordinator/dashboard",
    icon: <RiDashboardFill size={20} />,
    element: <Dash />,
    children: [],
    role: [PROJECT_COORDINATOR],
  },
  {
    title: "Projects",
    path: "/emp-projects",
    icon: <GoProjectRoadmap size={20} />,
    element: <Projects />,
    children: [],
    role: [PROJECT_COORDINATOR],
  },

  {
    title: "Dashboard",
    path: "/client/dashboard",
    icon: <RiDashboardFill size={20} />,
    element: <ClientDashboard />,
    children: [],
    role: [CLIENT,CLIENT_VENDOR],
  },

  {
    title: "Add Info",
    path: "/add-project-info",
    icon: <MdAddBox size={20} />,
    element: <ClientProjects/>,
    children: [],
    role: [CLIENT,CLIENT_VENDOR],
  },
  {
    title: "Projects",
    path: "/client-projects",
    icon: <GoProjectRoadmap size={20}/>,
    element: <ClientProjects />,
    children: [],
    role: [CLIENT,CLIENT_VENDOR],
  },

  {
    title: "Publication Status",
    path:"/client/articles",
    icon: <File size={20} />,
    element: <ArticlesClient />,
    children: [],
    role: [CLIENT,CLIENT_VENDOR],
  },
     

  {
    title: "Publication Status",
    path:"/submission-specialist/articles",
    icon: <File size={20} />,
    element: <Articles />,
    children: [],
    role: [SUBMISSION_SPECIALIST],
  },
];

export default routesdata;
